<div class="show-button d-flex justify-content-end align-items-center">
  <div
    class="filter-button-group mt-0"
    *ngIf="
      filter['layout'] !== 'collection_offcanvas_filter' &&
      filter['layout'] !== 'collection_no_sidebar'
    "
  >
    <div class="filter-button d-inline-block d-lg-none">
      <a (click)="openFilter(true)" data-cta="list.filter_open" data-cta-loc="product_list"
        ><i class="ri-search-fill"></i> {{ "Bộ lọc theo NSX" | translate }}</a
      >
    </div>
  </div>
  <!--
  <div class="top-filter-menu">
    <div class="category-dropdown ">
      <a
        href="javascript:void(0)"
        class="filter-offcanvas-title"
        (click)="openOffCanvasMenu()"
        *ngIf="filter && filter['layout'] == 'collection_offcanvas_filter'"
      >
        <i class="ri-filter-2-fill"></i> {{ "Danh Mục" | translate }}
      </a>
      <div class="text-content me-2">Xếp theo:</div>

      <div class="sort-dropdown" [class.open]="isSortOpen">
        <button type="button" class="sort-trigger" (click)="toggleSort()">
          <i [class]="selectedSort?.iconClasses || 'ri-sort-desc'" style="font-size: 20px;"></i>
          <span>{{ selectedSort?.label || 'Chọn sắp xếp' }}</span>
          <i class="ri-arrow-down-s-line arrow" style="font-size: 20px;"></i>
        </button>
        <div class="sort-menu" *ngIf="isSortOpen">
          <div
            class="sort-option"
            [ngClass]="{ 'active': sort.value === selectedSort?.value }"
            *ngFor="let sort of sorting"
            (click)="selectSort(sort)" data-cta="list.sort" data-cta-loc="product_list"
          >
            <i [class]="sort?.iconClasses || 'ri-sort-desc'" style="font-size: 20px;"></i>
            {{ sort.label }}
          </div>
        </div>
      </div>
    </div>
    <div class="grid-option d-none d-md-block">
      <ul>
        <li
          class="three-grid"
          [class.active]="selectedGrid == 'collection_3_grid'"
        >
          <a href="javascript:void(0)" (click)="grid('collection_3_grid')">
            <img src="assets/svg/grid-3.svg" alt="sort"  loading="lazy" />
          </a>
        </li>
        <li
          class="grid-btn d-xxl-inline-block d-none"
          [class.active]="selectedGrid == 'collection_4_grid'"
        >
          <a href="javascript:void(0)" (click)="grid('collection_4_grid')">
            <img
              src="assets/svg/grid-4.svg"
              class="d-lg-inline-block d-none"
              alt="sort"
             loading="lazy" />
            <img
              src="assets/svg/grid.svg"
              class="img-fluid d-lg-none d-inline-block"
              alt="sort"
             loading="lazy" />
          </a>
        </li>
        <li
          class="grid-btn d-xxl-inline-block d-none"
          [class.active]="selectedGrid == 'collection_5_grid'"
        >
          <a href="javascript:void(0)" (click)="grid('collection_5_grid')">
            <img
              src="assets/svg/grid-5.svg"
              class="d-lg-inline-block d-none"
              alt="sort"
             loading="lazy" />
            <img
              src="assets/svg/grid.svg"
              class="img-fluid d-lg-none d-inline-block"
              alt="sort"
             loading="lazy" />
          </a>
        </li>
        <li
          class="list-btn"
          [class.active]="selectedGrid == 'collection_list_view'"
        >
          <a href="javascript:void(0)" (click)="grid('collection_list_view')">
            <img src="assets/svg/list.svg" alt="sort"  loading="lazy" />
          </a>
        </li>
      </ul>
    </div>
  </div> -->
</div>

